import React from "react";

// Source file has generous black padding baked around the mark, so we scale the
// image up and let the rounded container clip it — keeps the mark itself large
// and legible instead of shrinking to a speck inside the icon box.
export default function EquityLogo({ size = 22, className = "" }) {
  return (
    <img
      src="/logo.jpg"
      alt="Equity CRM"
      className={`object-cover ${className}`}
      style={{ width: size, height: size, transform: "scale(1.8)" }}
    />
  );
}
